export default {
    name: 'mvtLinkList',
    props: {
        listHeight: {
            type: String,
            default: '145px',
        },
        itemWidth: {
            type: String,
            default: '360px',
        },
        showMoreHref: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showMore: false,
        };
    },
    computed: {
        style() {
            if (!this.listHeight) {
                return { 'grid-template-columns': `repeat(auto-fit, minmax(${this.itemWidth}, 1fr))` };
            }
            return { 'grid-template-columns': `repeat(auto-fit, minmax(${this.itemWidth}, 1fr))`, 'max-height': this.listHeight };
        },
    },
    methods: {
        open() {
            this.showMore = true;
        },
        close() {
            this.showMore = false;
        },
    },
};
